// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MailItemView_wrap__29ghL"};